import React, { useState, useEffect } from 'react';
import { OIDCReactLib } from "@bnsf/oidc-token-lib-react";
import { useOidc } from '@bnsf/oidc-token-lib-react/lib';
import { connect, useDispatch } from 'react-redux';
import { isUserAuthorized } from '../../redux/actions/isUserAuthorized';
import { manageTheme } from '../../redux/actions/manageTheme';
import { setView } from '../../redux/actions/setView';
import { setFilter } from '../../redux/actions/setFilter';
import { setDataReload } from '../../redux/actions/setDataReload';
import { ToastsContainer, ToastsStore } from '@bnsf/bnsf-react-toast-messages';
import toastMessages from '../../constants/toastMessages.json';
import { VIEW } from '../../constants/appConstants';


import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import HomeView from '../views/HomeView';
import WindowListView from '../views/WindowListView';
import WindowEditView from '../views/WindowEditView';
import FilterView from '../views/FilterView';

import { retrieveEnvironmentVars } from '../../services/trackWindow';

import 'gel-bootstrap-4/dist/css/gray-dark-gel.min.css';
import './App.css';
import { setOidcObj } from '../../redux/actions/setOIDC';

let userProfile;
const oauthConfig = {
  callBackURI: "https://localhost:18732/authgrantflowredirect",
  clientId: "HEqMofL0cAlh0stH2yja",
  clientSecret: "3KymGEHN8FYpP05kNQX8",
  issuerURI: "https://localhost:18732",
  scope: "profile https://bwwp-mobile-api-gateway-dev.bwwp-mobile-nonprod.bnsf.com https://bwwp-mobile-api-gateway-tr.bnsf.com https://gis-api-dev.gis-nonprod.bnsf.com",
}

const App = (props) => {
  const [filterVisible, setFilterVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const { authUser } = useOidc();
  const dispatch = useDispatch();
  const userProfileKey = 'oidc_user_profile';

  useEffect(() => {
    if (!authUser) return;
    if (authUser?.profile?.family_name && authUser?.profile?.given_name) {
      userProfile = authUser.profile;
      let _tempUserNameObj = {
        given_name: userProfile.given_name,
        family_name: userProfile.family_name,
        name: userProfile.name,
      }

      localStorage.setItem(userProfileKey, JSON.stringify(_tempUserNameObj));

    } else {
      const _local_userProfile = JSON.parse(localStorage.getItem(userProfileKey));

      if (_local_userProfile) {
        authUser.profile["given_name"] = _local_userProfile.given_name;
        authUser.profile["family_name"] = _local_userProfile.family_name;
        authUser.profile["name"] = _local_userProfile.name;
      }
    }

    if (userProfile) {
      dispatch(setOidcObj(authUser));
      retrieveEnvironmentVars().then(
        () => setLoaded(true),
        () => ToastsStore.showToast("CONFIG_FAILURE"));
    }

  }, [authUser]);

  /* if window closed localStorage should be reset  */
  const handleBeforeUnload = () => {
    localStorage.removeItem(userProfileKey);
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    userProfile = authUser && authUser.profile;

    if (userProfile && loaded) {
      props.isUserAuthorized(userProfile);
    }

  }, [authUser, loaded]);

  useEffect(() => {
    if (!loaded) return;

    props.setView(VIEW.HOME_VIEW);

  }, [loaded]);

  const showFilter = () => {
    setFilterVisible(true);
  };

  const hideFilter = () => {
    setFilterVisible(false);
  };

  const applyFilter = (filter) => {
    setFilterVisible(false);
    props.setFilter(props.view.current, filter);

    props.setDataReload(true);
  }

  const switchView = (newView, params) => {
    props.setView(newView, params);

    if (newView === VIEW.WINDOW_LIST_VIEW || newView === VIEW.MY_WINDOW_VIEW) {
      props.setDataReload(true);
    }
  };

  const view = props.view;
  let viewComponent;

  switch (view.current) {
    case VIEW.HOME_VIEW:
      viewComponent = (<HomeView switchView={switchView} />);
      break;
    case VIEW.WINDOW_LIST_VIEW:
      viewComponent = (<WindowListView switchView={switchView} />);
      break;
    case VIEW.WINDOW_EDIT_VIEW:
      viewComponent = (<WindowEditView switchView={switchView} data={view.params && view.params.winToEdit} />);
      break;
    case VIEW.NEW_WINDOW_VIEW:
      viewComponent = (<WindowEditView switchView={switchView} />);
      break;
    case VIEW.MY_WINDOW_VIEW:
      viewComponent = (<WindowListView switchView={switchView} />);
      break;
    default:
      viewComponent = null;
      break;
  }

  const activeFilter = props.windowFilter[view.current];

  return (
    <>
    {/* for enable the local oidc <OIDCReactLib oauthConfig={oauthConfig}  />*/}
      <OIDCReactLib oauthConfig={process.env.NODE_ENV === 'development' ? oauthConfig : undefined} />
      
      {
        (loaded ?
          (userProfile ?
            (
              <div className='wrapper'>
                <Header userProfile={userProfile} />
                <div className='app-container'>
                  {viewComponent}
                </div>
                <FilterView show={filterVisible} data={activeFilter} onHide={hideFilter} onApply={applyFilter} />
                {props.view.current !== VIEW.HOME_VIEW ? <Footer setView={switchView} showFilter={showFilter} /> : null}

                <ToastsContainer store={ToastsStore} toastData={toastMessages} />
              </div>
            ) : (
              <div>You are not authorized to use the app.</div>
            )
          ) : null
        )
      }
    </>

  )

}

const mapStateToProps = (state) => {
  return {
    user: state.oidc.user,
    isAuthorized: state.isAuthorized,
    headerTitle: state.modals.headerTitle,
    currentTheme: state.currentTheme,
    view: state.view,
    windowFilter: state.windowFilter
  };
}

const mapDispatchToProps = dispatch => {
  return {
    isUserAuthorized: (userProfile) => dispatch(isUserAuthorized(userProfile)),
    manageTheme: (theme) => dispatch(manageTheme(theme)),
    setView: (view, params) => dispatch(setView(view, params)),
    setFilter: (view, filter) => dispatch(setFilter(view, filter)),
    setDataReload: (reload) => dispatch(setDataReload(reload))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
